export default "<iframe\n  src=\"https://awmt-placement.vercel.app/portal/facilities\"\n  width=\"100%\"\n  height=\"100%\"\n  frameborder=\"0\">\n</iframe>"